import React from 'react'

import Thereturn from "../Video/Thereturn.mp4";
import { Pane, Paragraph } from 'evergreen-ui'
function Thereturns(props){
  return (
      <div className="App">
            <video
              autoPlay
              loop
              muted
              style={{
                position: "absolute",
                width: "100%",
                left: "50%",
                top: "50%",
                height: "100%",
                objectFit: "cover",
                transform: "translate(-50%, -50%)",
                zIndex: "-1"
              }}
            >
          <source src ={Thereturn} type="video/mp4" />

          </video>
          <Pane clearfix>

          <Pane
          background="transparent"
          elevation={0}
          float="left"
          width={500}
          height={150}
          margin={24}
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          >
          <Paragraph color="white" marginTop="default">
  This is a large 3D level that was created with exploration being the goal. The terrain was all created by hand as well as everything else in the level. This project was done for a class assignment.
          </Paragraph>

          </Pane>
            <Pane
            background="transparent"
            elevation={0}
            float="right"
            width={500}
            height={150}
            margin={300}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            >
              <Paragraph color="white" marginTop="default">
Throughout the level there are three different collectables that the player must collect, all leading to a final area where the player gets to see the whole level sprawled out in front of them. The goal of this level was to create a level driven through narrative and exploration.
              </Paragraph>

                </Pane>
              </Pane>
              <Pane
              background="transparent"
              elevation={0}
              float="left"
              width={500}
              height={150}
              margin={5}
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              >
                <Paragraph color="white" marginTop="default">
                Creating this level taught me a lot about scope, in regards to level design, being able to describe and properly decide the scale of a level. Making a level too large and complex leaves players feeling small and unimportant. This balance is the goal of every level designer.
                </Paragraph>

                  </Pane>
          </div>
        );
  };
export default Thereturns;
